import {memo} from 'react'
import {format} from 'date-fns'
import {Text} from '@/components/ui/text/Text'
import {StyledDateHeader} from './style'

interface DateHeaderProps {
    date: string
}

const DateHeaderComponent = ({date}: DateHeaderProps) => {
    const formattedDate = format(new Date(date), 'dd/MM/yyyy')

    return (
        <StyledDateHeader fullWidth justify="center">
            <Text size="textXs" palette="neutral" shade="500" weight="500">
                {formattedDate}
            </Text>
        </StyledDateHeader>
    )
}

export const DateHeader = memo(DateHeaderComponent)
